import $ from "jquery"

// jQuery must be a global before materialize-css evaluates (it registers its
// $.fn plugin shims only if it finds jQuery), and inline template scripts
// (cornerpopup.html, newsletter-popup.html) call $.fn.cornerpopup directly.
window.$ = window.jQuery = $

export default $
